import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHeader, EmptyState } from "../../components/Common";
import { useAuth } from "../../lib/auth";
import { Trophy } from "lucide-react";
import { useDataSync } from "../../lib/realtime";

const MEDALS = ["🥇", "🥈", "🥉"];

export default function StudentLeaderboard() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);

  const load = async () => { const { data } = await api.get("/leaderboard"); setRows(data); };
  useEffect(() => { load(); }, []);
  useDataSync(["leaderboard", "attempts"], () => load());

  const topPct = rows[0]?.avg_percent ?? 0;

  return (
    <div>
      <PageHeader title="Leaderboard" subtitle="Ranked by percentage across all published test results." />
      {rows.length === 0 ? (
        <EmptyState title="No scores yet" desc="Be the first to attempt a test!" icon={Trophy} />
      ) : (
        <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
          <div className="grid grid-cols-12 px-5 py-3 border-b border-slate-100 bg-slate-50 text-[10px] font-bold uppercase tracking-wider text-slate-500">
            <div className="col-span-1">Rank</div>
            <div className="col-span-5">Student</div>
            <div className="col-span-3 hidden sm:block">Batch</div>
            <div className="col-span-2 text-right">Marks</div>
            <div className="col-span-1 sm:col-span-1 text-right">%</div>
          </div>
          {rows.map((r, i) => {
            const me = r.student_id === user.id;
            const isTop = r.avg_percent === topPct && r.avg_percent > 0;
            return (
              <div key={r.student_id} data-testid={`lb-row-${i}`}
                className={`grid grid-cols-12 items-center px-5 py-4 border-b border-slate-100 last:border-0 ${me ? "bg-blue-50" : isTop ? "bg-amber-50/40" : "hover:bg-slate-50"}`}>
                <div className="col-span-1">
                  <div className="w-9 h-9 rounded-full bg-slate-100 grid place-items-center font-heading font-black text-slate-600">
                    {i < 3 ? <span className="text-xl">{MEDALS[i]}</span> : r.rank}
                  </div>
                </div>
                <div className="col-span-5">
                  <div className="font-semibold text-slate-900">
                    {r.student_name}
                    {me && <span className="ml-2 text-xs text-blue-600 font-bold">YOU</span>}
                    {isTop && <span className="ml-2 text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-700">TOP</span>}
                  </div>
                  <div className="text-xs text-slate-500">{r.tests} tests</div>
                </div>
                <div className="col-span-3 hidden sm:block text-sm text-slate-600 truncate">
                  {r.batch_name || "—"}
                </div>
                <div className="col-span-2 text-right text-sm font-mono text-slate-700">
                  {r.total_score}/{r.total_max}
                </div>
                <div className="col-span-1 text-right">
                  <span className="font-heading font-black text-xl text-blue-600">{r.avg_percent}%</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
